var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFlagFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.654 3.58c-1.185 0-2.469-.197-3.654-.79S9.531 2 8.346 2C5.976 2 4 2.79 4 2.79v18.457a.75.75 0 101.5 0v-8.234c.768-.18 1.76-.346 2.846-.346 1.185 0 2.469.197 3.654.79 1.186.592 2.469.79 3.654.79 2.37 0 4.346-.79 4.346-.79V2.79s-1.975.79-4.346.79z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagFilled);
export default new URL("/builds/software-solutions/workspace/web/eagleid-fe-workspace/src/images/iconFlagFilled.svg", import.meta.url).toString();
export { ForwardRef as ReactComponent };